import React, { Component } from 'react';
import { browserHistory } from 'react-router';

class SelectProduct extends Component {
  constructor(props) {
    super(props);
    this.selectProductModal = null;
  }

  componentDidMount() {
    this.selectProductModal = new window.bootstrap.Modal(window.$('#selectProductModal'));
  }

  _onSaveSelectedProduct = () => {
    const {
      product, onSave, caseRes, acmProduct
    } = this.props;
    onSave(product);
    if (acmProduct) {
      browserHistory.push(`/manage-case/${caseRes.id}/acm-products`);
    } else {
      browserHistory.push(`/manage-case/${caseRes.id}/acm-products/select`);
    }
    this.selectProductModal.hide();
  }

  render() {
    const { product, onCancel, acmProduct } = this.props;
    return (
      <div
        className="modal fade theme-modal qty-modal" id="selectProductModal"
        tabIndex="-1"
        aria-labelledby="selectProductModalLabel" aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title" id="selectProductModalLabel">Select this product?</h5>
              <p>{acmProduct ? product.productId : product.ProductNo}<br />
                {product.ProductDescription}
              </p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2 button-wrap">
                <div className="col-6">
                  <button type="button" className="btn btn-link btn-left w-100" data-bs-dismiss="modal" onClick={() => onCancel()}>No</button>
                </div>
                <div className="col-6">
                  <button type="button" className="btn btn-link w-100" onClick={this._onSaveSelectedProduct}>Yes</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SelectProduct;
